import React, {PropTypes} from 'react';
const Loading = require('react-loading');
import '../../styles/common/Loading.css';

const LoadingCircle = ({loading}) => {
  return (
    <div id="loading-circle" hidden={!loading}>
      <div className="loading-text">
        <h1>Loading...</h1>
      </div>
      <Loading type="spin" color="#e3e3e3"/>
    </div>
  );
};

LoadingCircle.propTypes = {
  loading: PropTypes.bool.isRequired
};

export default LoadingCircle;



/** WEBPACK FOOTER **
 ** ./src/components/common/LoadingCircle.js
 **/